// extracted by mini-css-extract-plugin
module.exports = {"thecomp":"Products_thecomp__Zsoto"};